import { useEffect } from 'react';
import { RunnerBridge } from '../../../../helpers';
import SherloModule from '../../../../SherloModule';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isStorybook7 } from '../../../helpers';
import { prepareInspectorData } from './prepareInspectorData';
function useTestStory({ metadataProviderRef, }) {
    const config = SherloModule.getConfig();
    const lastState = SherloModule.getLastState();
    const insets = useSafeAreaInsets();
    useEffect(() => {
        (async () => {
            var _a, _b, _c;
            try {
                if (!lastState)
                    return;
                const { nextSnapshot, requestId } = lastState;
                RunnerBridge.log('attempt to test story', {
                    nextSnapshot,
                    requestId,
                });
                // We wait until the story is displayed in the UI
                // before we start stabilizing and taking screenshots
                // This is to avoid taking screenshots of the loading state
                let storyIsDisplayed = false;
                let waitCount = 0;
                while (!storyIsDisplayed) {
                    const controlFabricMetadata = JSON.stringify((_a = metadataProviderRef === null || metadataProviderRef === void 0 ? void 0 : metadataProviderRef.current) === null || _a === void 0 ? void 0 : _a.collectMetadata());
                    if (controlFabricMetadata.includes(nextSnapshot.storyId)) {
                        RunnerBridge.log('story is displayed');
                        storyIsDisplayed = true;
                        break;
                    }
                    RunnerBridge.log('waiting for story to be displayed', {
                        waitCount,
                    });
                    await new Promise((resolve) => setTimeout(resolve, 500));
                    waitCount++;
                }
                const isStable = await SherloModule.stabilize(config.stabilization.requiredMatches, config.stabilization.minScreenshotsCount, config.stabilization.intervalMs, config.stabilization.timeoutMs, !!config.stabilization.saveScreenshots).catch((error) => {
                    RunnerBridge.log('error checking if stable', { error: error.message });
                    throw error;
                });
                RunnerBridge.log('checked if stable', { isStable });
                let inspectorData;
                while (!inspectorData) {
                    inspectorData = await SherloModule.getInspectorData().catch((error) => {
                        RunnerBridge.log('error getting inspector data', { error: JSON.stringify(error) });
                    });
                }
                RunnerBridge.log('got inspector data');
                const fabricMetadata = (_b = metadataProviderRef === null || metadataProviderRef === void 0 ? void 0 : metadataProviderRef.current) === null || _b === void 0 ? void 0 : _b.collectMetadata();
                RunnerBridge.log('got fabric metadata');
                const containsError = fabricMetadata === null || fabricMetadata === void 0 ? void 0 : fabricMetadata.texts.includes('Something went wrong rendering your story');
                const rendersRemoteImages = !!(fabricMetadata === null || fabricMetadata === void 0 ? void 0 : fabricMetadata.rendersRemoteImages);
                let finalInspectorData;
                let safeAreaMetadata;
                if (!containsError) {
                    finalInspectorData = fabricMetadata
                        ? prepareInspectorData(inspectorData, fabricMetadata, nextSnapshot.storyId)
                        : inspectorData;
                    safeAreaMetadata = {
                        shouldAddSafeArea: !((_c = nextSnapshot.parameters) === null || _c === void 0 ? void 0 : _c.noSafeArea),
                        insetBottom: Math.round(insets.bottom * finalInspectorData.density),
                        insetTop: Math.round(insets.top * finalInspectorData.density),
                        isStorybook7,
                    };
                }
                RunnerBridge.log('inspector data', {
                    fabricMetadata,
                    inspectorData,
                    finalInspectorData,
                });
                RunnerBridge.log('requesting screenshot from master script', {
                    action: 'REQUEST_SNAPSHOT',
                    hasError: containsError,
                    finalInspectorData: !!finalInspectorData,
                    isStable,
                    requestId: requestId,
                    safeAreaMetadata,
                    rendersRemoteImages,
                });
                await RunnerBridge.send({
                    action: 'REQUEST_SNAPSHOT',
                    hasError: containsError,
                    inspectorData: JSON.stringify(finalInspectorData),
                    isStable,
                    requestId: requestId,
                    safeAreaMetadata,
                    rendersRemoteImages,
                });
            }
            catch (error) {
                // @ts-ignore
                RunnerBridge.log('story capturing failed', { errorMessage: error === null || error === void 0 ? void 0 : error.message });
            }
        })();
    }, []);
}
export default useTestStory;
//# sourceMappingURL=useTestStory.js.map